import HeaderSearchButtons from "@pages/dvtjcuv/rundvtjcuv/HeaderSearchButtons";
import React, { useEffect, useState } from "react";
import { DVTJCUVCddOpenAndNotSddvParentTabs } from "@pages/dvtjcuv/common/CddOpenAndNotSddvTabs";
import CddOpenAndNotSddvContent from "@pages/dvtjcuv/rundvtjcuv/cddopenandnotsddv/CddOpenAndNotSddvContent";
import { DVTJCUVPipelineBlock } from '@pages/dvtjcuv/common/Constant';

const CddOpenAndNotSddvManager = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [currentParentTab, setCurrentParentTab] = useState(DVTJCUVCddOpenAndNotSddvParentTabs.PRIORITY_PROCESS_TAB);
    const [runJobInfo, setRunJobInfo] = useState({
        email_tab: {}
    });

    const {runJob} = props;

    const hash = window.location.hash.substring(1);

    useEffect(() => {
        if (runJob) {
            setRunJobInfo({...runJob});
        }
    }, [runJob]);

    useEffect(() => {
        Object.values(DVTJCUVCddOpenAndNotSddvParentTabs).forEach(tab => {
            if (hash && hash === tab.id) {
                setCurrentParentTab(tab);
            }
        });
    }, []);

    const activeTab = (tab) => {
        if (currentParentTab.id === tab.id) {
            return 'active';
        }
        return '';
    };

    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">CDDs OPEN & CHƯA SDDV</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
                <div className="card-tools pr-2 col-6">
                    <HeaderSearchButtons
                        parentTabId={DVTJCUVPipelineBlock.CddOpenAndNotSddvManager}
                        showBtnSearchPipeline
                        showBtnSearchCdd
                        showBtnSearchReceiver
                        showBtnSearchEmployer
                    />
                </div>
            </div>
            <div className="card-body">
                <ul className='nav nav-tabs' role='tablist'>
                    {Object.values(DVTJCUVCddOpenAndNotSddvParentTabs).map(tab => (
                        <li className='nav-item' key={tab.id}>
                            <a className={`nav-link ${activeTab(tab)}`} 
                               data-toggle='tab' 
                               href={`#${tab.id}`}
                               onClick={() => {
                                   setCurrentParentTab(tab);
                                   window.location.hash = tab.id;
                               }}>
                                {tab.title}
                            </a>
                        </li>
                    ))}
                </ul>
                <div className='tab-content'>
                    {Object.values(DVTJCUVCddOpenAndNotSddvParentTabs).map((tab) => {
                        if (currentParentTab.id === tab.id) {
                            return (
                                <div id={tab.id} className={`tab-pane active`} key={tab.id}>
                                    <CddOpenAndNotSddvContent 
                                        data={runJobInfo} 
                                        parentTab={tab}
                                    />
                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        </div>
    );
};

export default CddOpenAndNotSddvManager; 